import { message } from 'antd'
import { takeLatest, all, put } from 'redux-saga/effects'
import Api from "../../common/api"

import { TimelineTrainingActions } from './TimelineTrainingSlice'
import { TimelineActions } from '../Timeline/TimelineSlice'

function* getTimelineTrainings({ payload }) {
  const d = yield Api.get(`/timelineTraining/byUserId?userId=${payload.userId}`)
  if (d.ok) {
    yield put(TimelineTrainingActions.setTimelineTrainings(d.payload))
  } else {
    message.error(d.payload.message)
  }
}

function* createTimelineTraining({ payload }) {
  const d = yield Api.post(`/timelineTraining`, payload)
  if (d.ok) {
    message.success('Cronograma de capacitación creado con éxito')
  } else {
    message.error("Error al crear el cronograma de capacitación")
  }
  yield put(TimelineTrainingActions.setCreateTimelineTrainingLoading(false))
}

function* editTimelineTraining({ payload }) {
  const d = yield Api.post(`/timelineTraining/edit`, payload)
  if (d.ok) {
    message.success('Cronograma de capacitación editado con éxito')
  } else {
    message.error("Error al editar el cronograma de capacitación")
  }
  yield put(TimelineTrainingActions.setCreateTimelineTrainingLoading(false))
}

function* actionWatcher() {
  yield takeLatest(TimelineTrainingActions.getTimelineTrainings, getTimelineTrainings)
  yield takeLatest(TimelineTrainingActions.createTimelineTraining, createTimelineTraining)
  yield takeLatest(TimelineTrainingActions.editTimelineTraining, editTimelineTraining)
}

export default function* TimelineTrainingSaga() {
  yield all([actionWatcher()])
}